webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(16);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLinkStyle = (0, _glamor.css)({
	    textDecoration: "none",
	    textTransform: "uppercase",
	    margin: "0 0.5em",
	    fontSize: "0.75em",
	    ':last-child': {
	        marginRight: 0
	    }
	});
	
	var Footer = _glamorous2.default.footer({
	    borderTop: "2px solid black",
	    textAlign: "right",
	    padding: "2em 0"
	});
	
	var MenuList = _glamorous2.default.ul({
	    listStyleType: "none"
	});
	
	var MenuItem = _glamorous2.default.li({
	    display: "inline"
	});
	
	exports.default = function () {
	    return _react2.default.createElement(
	        Footer,
	        null,
	        _react2.default.createElement(
	            MenuList,
	            null,
	            _react2.default.createElement(
	                MenuItem,
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://www.instagram.com/geoframsay/?hl=en", target: "_blank", className: NavLinkStyle },
	                    "Instagram"
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _mediaQueries$phone, _g$div, _css, _g$div2, _css2, _g$div3, _css3;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(16);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(47);
	
	var _breakpoints = __webpack_require__(135);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLinkStyle = (0, _glamor.css)({
	    textDecoration: "none",
	    textTransform: "uppercase",
	    margin: "0 1.5em",
	    ':last-child': {
	        marginRight: 0
	    }
	});
	
	var SocialNavLinkStyle = (0, _glamor.css)({
	    margin: "0 2.75em",
	    textDecoration: "none",
	    textTransform: "uppercase",
	    ':last-child': {
	        marginRight: 0
	    }
	});
	
	var MenuContainer = _glamorous2.default.div((_g$div = {
	    position: "relative",
	    textAlign: "right",
	    float: "right",
	    paddingTop: (0, _typography.rhythm)(0.5)
	}, _g$div[_breakpoints2.default.phone] = (_mediaQueries$phone = {
	    float: "none",
	    textAlign: "center",
	    position: "fixed",
	    top: 0,
	    left: 0,
	    width: "100vw",
	    height: "100vh",
	    background: "white",
	    zIndex: 1000,
	    display: "flex",
	    flexDirection: "column",
	    justifyContent: "center",
	    alignItems: "center",
	    opacity: 0,
	    pointerEvents: "none",
	    transition: "all 0.25s linear"
	}, _mediaQueries$phone["zIndex"] = 1000, _mediaQueries$phone), _g$div));
	
	var MenuOpen = (0, _glamor.css)((_css = {}, _css[_breakpoints2.default.phone] = {
	    opacity: "1 !important",
	    pointerEvents: "all !important",
	    overflow: "hidden !important",
	    maxWidth: "100vw !important",
	    maxHeight: "100vh !important"
	}, _css));
	
	var SocialContainer = _glamorous2.default.div((_g$div2 = {
	    position: "absolute",
	    right: "0",
	    top: "7em",
	    fontSize: "0.678125em"
	}, _g$div2[_breakpoints2.default.phone] = {
	    float: "none",
	    textAlign: "center",
	    top: "4em"
	}, _g$div2));
	
	var ActiveLinkStyle = (0, _glamor.css)((_css2 = {
	    position: "relative",
	    ':after': {
	        position: "absolute",
	        top: "2em",
	        left: "50%",
	        transform: "translateX(-50%)",
	        content: " ",
	        width: "2em",
	        height: "4px",
	        background: "black"
	    }
	}, _css2[_breakpoints2.default.phone] = {
	    ':after': {
	        display: "none"
	    }
	}, _css2));
	
	var MenuToggle = _glamorous2.default.div((_g$div3 = {
	    position: "absolute",
	    top: "-2.75em",
	    fontSize: "0.75em",
	    left: "50%",
	    transform: "translateX(-50%) translateY(-50%)",
	    cursor: "pointer",
	    display: "none",
	    zIndex: 1001,
	    ':hover,:active,:focus': {
	        opacity: 0.8
	    }
	}, _g$div3[_breakpoints2.default.phone] = {
	    display: "block"
	}, _g$div3));
	
	var getNavIsActive = function getNavIsActive(match, location) {
	    if (!match) return false;
	    return location.pathname === match.path || location.pathname.startsWith('/work/');
	};
	
	var HeaderStyle = (0, _glamor.css)((_css3 = {
	    marginBottom: (0, _typography.rhythm)(2),
	    display: "inline-block",
	    fontStyle: "normal",
	    position: "relative",
	    zIndex: 1001
	}, _css3[_breakpoints2.default.phone] = {
	    width: "100%",
	    display: "block",
	    textAlign: "center"
	}, _css3));
	
	var toggleMenu = function toggleMenu() {
	    //console.info(MenuContainer.className)
	    var body = document.getElementsByTagName('body')[0];
	    var menu = document.getElementsByClassName('menu')[0];
	    body.classList.toggle(MenuOpen);
	    menu.classList.toggle(MenuOpen);
	};
	
	var menuClicked = function menuClicked() {
	    var body = document.getElementsByTagName('body')[0];
	    var menu = document.getElementsByClassName('menu')[0];
	    menu.classList.remove(MenuOpen);
	    body.classList.remove(MenuOpen);
	};
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _glamorous2.default.Nav,
	        { position: "relative", marginBottom: "2em" },
	        _react2.default.createElement(
	            MenuToggle,
	            { onClick: toggleMenu },
	            "Menu"
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(
	                "h1",
	                { className: HeaderStyle },
	                _react2.default.createElement(
	                    _glamorous2.default.Span,
	                    { display: "none" },
	                    "Geof Ramsay"
	                ),
	                _react2.default.createElement("img", { src: "/images/logo.svg", alt: "GeofRamsay Logo", style: { width: "8.67em" } })
	            )
	        ),
	        _react2.default.createElement(
	            MenuContainer,
	            { className: "menu" },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { activeClassName: ActiveLinkStyle, className: NavLinkStyle, to: "/", isActive: getNavIsActive, onClick: menuClicked },
	                "Work"
	            ),
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { activeClassName: ActiveLinkStyle, className: NavLinkStyle, to: "/about/", onClick: menuClicked },
	                "About"
	            ),
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { activeClassName: ActiveLinkStyle, className: NavLinkStyle, to: "/contact/", onClick: menuClicked },
	                "Contact"
	            )
	        ),
	        _react2.default.createElement(
	            SocialContainer,
	            null,
	            _react2.default.createElement(
	                "a",
	                { href: "https://www.instagram.com/geoframsay/?hl=en", target: "_blank", className: SocialNavLinkStyle },
	                "Instagram"
	            )
	        )
	    );
	};
	
	//export default Navigation
	

	module.exports = exports["default"];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _g$div;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _typography = __webpack_require__(47);
	
	var _breakpoints = __webpack_require__(135);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _glamorous2.default.div((_g$div = {
	    margin: "0 auto",
	    maxWidth: "1160px",
	    padding: (0, _typography.rhythm)(1),
	    paddingTop: (0, _typography.rhythm)(3),
	    position: "relative"
	}, _g$div[_breakpoints2.default.phone] = {}, _g$div));
	module.exports = exports["default"];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(16);
	
	var _pageContainer = __webpack_require__(210);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	var _navigation = __webpack_require__(209);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(80);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import WorkListItem from "../components/work-list-item.js"
	//import ProductList from "../components/product-list.jsx"
	
	var WorkAside = _glamorous2.default.aside({
	    paddingTop: "1.5em",
	    ':before': {
	        borderTop: "1px solid black",
	        content: " ",
	        width: "100%",
	        display: "block",
	        marginBottom: "3em"
	    }
	});
	
	var Main = _glamorous2.default.main({
	    overflow: "auto"
	});
	
	exports.default = function (_ref) {
	    var children = _ref.children,
	        data = _ref.data;
	    return _react2.default.createElement(
	        _pageContainer2.default,
	        null,
	        _react2.default.createElement(_navigation2.default, null),
	        _react2.default.createElement(
	            Main,
	            null,
	            children()
	        ),
	        _react2.default.createElement(_footer2.default, null)
	    );
	};
	
	/*export const query = graphql`
	    query LayoutQuery {
	        site {
	            siteMetadata {
	                title
	            }
	        }
	        allContentfulWork(limit: 1000) {
	            totalCount
	            edges {
	                node {
	                    id
	                    title
	                    photos {
	                        description
	                        file {
	                            url
	                        }
	                    }
	                    fields {
	                        slug
	                    }
	                }
	            }
	        }
	    }
	`*/


	module.exports = exports["default"];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	'use strict';
	
	var mediaQueries = {
	    phone: '@media only screen and (max-width: 750px)'
	};
	
	module.exports = mediaQueries;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-553a1729e2b9ac42b41b.js